import { render, staticRenderFns } from "./TwitterFeedWidget.vue?vue&type=template&id=05f51d78&scoped=true"
import script from "./TwitterFeedWidget.vue?vue&type=script&lang=js"
export * from "./TwitterFeedWidget.vue?vue&type=script&lang=js"
import style0 from "./TwitterFeedWidget.vue?vue&type=style&index=0&id=05f51d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f51d78",
  null
  
)

export default component.exports